import { render } from "./FeedbackDrawer.vue?vue&type=template&id=9ca7c5a4&scoped=true"
import script from "./FeedbackDrawer.vue?vue&type=script&lang=js"
export * from "./FeedbackDrawer.vue?vue&type=script&lang=js"

import "./FeedbackDrawer.vue?vue&type=style&index=0&id=9ca7c5a4&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ca7c5a4"]])

export default __exports__